import { Stack } from "@mui/material";
import { Button, Card, Icon, Typography } from "@platform/design-system";

interface Props {
  onRun: () => void;
}

/** What the Launchpad shows on an RFP Rumi has not run on: the way to start it. */
const RumiReady = ({ onRun }: Props): React.JSX.Element => (
  <Card padding="none" data-testid="rumi-ready">
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{ px: 2, py: 1 }}
    >
      <Icon name="ai" size="md" color="primary" />
      <Stack sx={{ flex: 1, py: 0.5 }}>
        <Typography variant="header-large" component="h2">
          Rumi is Ready
        </Typography>
        <Typography variant="caption">
          Press &ldquo;Run Rumi&rdquo; to have Rumi analyze this RFP.
        </Typography>
      </Stack>
      <Button onClick={onRun}>Run Rumi</Button>
    </Stack>
  </Card>
);

export { RumiReady };
export type { Props as RumiReadyProps };
